import QuestionType0 from './QuestionTypes/QuestionType0';
import QuestionType1 from './QuestionTypes/QuestionType1';
import QuestionType2 from './QuestionTypes/QuestionType2';
import QuestionType3 from './QuestionTypes/QuestionType3';
import QuestionType4 from './QuestionTypes/QuestionType4';
import QuestionType5 from './QuestionTypes/QuestionType5';
import QuestionType6 from './QuestionTypes/QuestionType6';
import QuestionType7 from './QuestionTypes/QuestionType7';

export default function ObligationFormQuestionSwitch(props) {
  const { question, isSubquestion = false } = props;

  switch (question.type) {
    // Yes/No
    case 0:
      return (
        <QuestionType0 question={question} isSubquestion={isSubquestion} />
      );
    // Single
    case 1:
      return (
        <QuestionType1 question={question} isSubquestion={isSubquestion} />
      );
    // Multi
    case 2:
      return (
        <QuestionType2 question={question} isSubquestion={isSubquestion} />
      );
    // Free text
    case 3:
      return (
        <QuestionType3 question={question} isSubquestion={isSubquestion} />
      );
    // Title
    case 4:
      return (
        <QuestionType4 question={question} isSubquestion={isSubquestion} />
      );
    // Subtitle
    case 5:
      return (
        <QuestionType5 question={question} isSubquestion={isSubquestion} />
      );
    // Note
    case 6:
      return (
        <QuestionType6 question={question} isSubquestion={isSubquestion} />
      );
    case 7:
      return (
        <QuestionType7 question={question} isSubquestion={isSubquestion} />
      );
    default:
      return undefined;
  }
}
